import './vendor.ts';

import {LOCALE_ID, NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {Ng2Webstorage} from 'ng2-webstorage';

import {CadensSharedModule, UserRouteAccessService} from './shared';
import {CadensHomeModule} from './home';
import {CadensAccountModule} from './account/account.module';
import {CadensEntityModule} from './entities/entity.module';
import {CadensAdminModule} from './admin/admin.module';

import {
    ActiveMenuDirective,
    ErrorComponent,
    FooterComponent,
    JhiMainComponent,
    LayoutRoutingModule,
    NavbarComponent,
    PageRibbonComponent,
    ProfileService
} from './layouts';
import {customHttpProvider} from './blocks/interceptor/http.provider';
import {PaginationConfig} from './blocks/config/uib-pagination.config';
import {Ng2PageScrollModule} from 'ng2-page-scroll';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import { JsUtil } from './shared/util/jsUtil';


@NgModule({
    imports: [
        BrowserModule,
        LayoutRoutingModule,
        Ng2PageScrollModule.forRoot(),
        Ng2Webstorage.forRoot({ prefix: 'jhi', separator: '-'}),
        CadensSharedModule,
        CadensHomeModule,
        CadensAccountModule,
        CadensEntityModule,
        CadensAdminModule
    ],
    declarations: [
        JhiMainComponent,
        NavbarComponent,
        ErrorComponent,
        PageRibbonComponent,
        ActiveMenuDirective,
        FooterComponent
    ],
    providers: [
        ProfileService,
        { provide: Window, useValue: window },
        { provide: Document, useValue: document },
        { provide: LOCALE_ID, useValue: 'fr-FR' },
        customHttpProvider(),
        PaginationConfig,
        UserRouteAccessService,
        NgbActiveModal,
        JsUtil
    ],
    bootstrap: [ JhiMainComponent ]
})
export class CadensAppModule {}



// WEBPACK FOOTER //
// ./src/main/webapp/app/app.module.ts